import React, { useEffect, useState } from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import avatar from "../../Assets/svg/avatar-img.svg";
import star from "../../Assets/svg/star.svg";
import exp from "../../Assets/svg/experience.svg";
import loc from "../../Assets/svg/location.svg";
import Button from "../modules/Button";
import ItemTab from "../modules/ItemTabs";
import ModalComponent from "../modules/Modal";
import Input from "../modules/Input";
import tick from "../../Assets/svg/green-bg-tick.svg";
import Avatars from "../modules/AvatarGroup";
// import PersonalProfile from "./personalProfile";
// import ProfessionalProfile from "./ProfessionalProfile";
// import EduProfile from "./EduProfile";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { api } from "../../Services";
import GradientLoader from "../modules/Loader";
import Alumni from "../AlumniMentorScreen";
import { GetLogout } from "../modules/Logout";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";
import { doLogout } from "../LoginPage/redux/actions";

function UserProfile(props) {
  const alumniProfile = useSelector((state) => state.connect?.alumniProfile);
  const alumniProfileType = useSelector(
    (state) => state.connect?.alumniProfileType
  );
  const dispatch = useDispatch();

  const id = useSelector((state) => state.connect.profileId);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [uploading, setUploading] = useState(false);
  const [Link, setLink] = useState("");

  const [proffInfo, setProffInfo] = useState({});
  const navigate = useNavigate();
  const [requestOption, setRequestOption] = useState({
    topic: "",
    comment: "",
  });
  const [skills, setSkills] = useState([
    "Resume Building",
    "Job and Internship applications",
    "Job Interviews",
    "Networking Skills",
    "Academics",
  ]);
  const [tab, setTab] = useState("Personal Details");
  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "Connection Request",
    countDown: " ",
    desc: "",
  });
  const [proSkills, setPro] = useState([
    "Marketing",
    "Leadership",
    "Product Ownership",
    "MS Excel",
    "Power BI",
    "Figma",
    "Search Engine Optimization",
    "Collaboration",
    "Powerpoint",
    "Chat GPT",
  ]);
  const [modelOptions, setModel] = useState([
    "Resume Building",
    "Job and Internship application",
    "Networking Skills",
    "Job Interviews",
    "Academics",
    "Something else",
  ]);
  const [concern, setConcern] = useState("");
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const scholarContent = () => {
    return (
      <div className="feedback-content">
        <Avatars type="scholars" />
        <div className=" md-title ">
          Find more than{" "}
          {alumniProfileType === "alumni"
            ? "250+ fellow scholars"
            : "100+ Alumni members"}{" "}
          on the platform
        </div>
        <div className="cred-btn">
          <Button
            onClickHandler={() => {
              alumniProfileType === "alumni"
                ? navigate("/application/connect/scholars")
                : navigate("/application/connect/alumni");
            }}
            value={"Start Networking"}
            type={"contained"}
          />
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"I’ll check it out later"}
            type={"only-text"}
          />
        </div>
      </div>
    );
  };
  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const makeRequest = async () => {
    // console.log("in checkModified after timer");
    // let noNullData=replaceNullsWithEmptyStrings(cleanObjectStrings(CombineData()))
    let data = {
      senderApplicationId: tokenData.applicationData.id,
      receiverApplicationId: id,
      isReceiverAlumni: alumniProfileType === "alumni" ? true : false,
      message: concern,
    };

    try {
      const request = await api.sendAlumniRequest(tokenData.token, data);
      console.log("users", request);
      if (
        request.statusCode !== 200 &&
        request.data.includes("Session expired")
      ) {
        logoutMsg();
      }
      return request;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      if (
        error?.statusCode !== 200 &&
        error?.data?.includes("Session expired")
      ) {
        logoutMsg();
      }
      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const checkRequest = async () => {
    setUploading(true);
    try {
      const request = await makeRequest();
      console.log("users", request);
      setUploading(false);
      if (request.statusCode == 200) {
        setModalData({
          ...ModalData,
          type: "submit",
          title: (
            <div className="set-title">
              <div className="happy-icon">
                <img src={tick} alt="tick" />
              </div>
              Connection request sent!
            </div>
          ),
          desc: "You’ll receive an update via email once your request is accepted.",
        });
      }
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      setUploading(false);

      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const mentorContent = () => {
    let item = alumniProfile.filter((a) => a.applicationId === id)[0];

    return (
      <div className="feedback-content">
        <div className="mentor-info">
          <div className="image img-section">
            {/* <img src={avatar} alt="avatar" /> */}
            {item?.image && item?.imageExtension && (
              <img
                // className="image"
                src={
                  item?.image && item?.imageExtension
                    ? "data:image/" +
                      item?.imageExtension +
                      ";base64," +
                      item?.image
                    : null
                }
                alt="Preview"
                // style={{ maxWidth: "100%", height: "100%" }}
              />
            )}
          </div>
          <div
            className="mentor-text"
            style={{ marginLeft: "2%", justifyContent: "space-between" }}
          >
            <span className="set-title">{item?.name || item?.fullName}</span>
            <span className="md-desc" style={{ color: "#222222" }}>
              {item?.name || item?.fullName}
            </span>
          </div>
        </div>

        <div className="comment-field">
          <Input
            onChange={(e) => setConcern(e.replace(/[^a-zA-Z0-9. ]/g, ""))}
            placeholder={"Could you tell us a little more?"}
            multiline={true}
          />
        </div>
        <div className="cred-btn">
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"Cancel"}
            type={"outlined"}
          />
          <Button
            onClickHandler={() => checkRequest()}
            value={"Connect"}
            type={"contained"}
          />
        </div>
      </div>
    );
  };
  useEffect(() => {
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    setLink(cleanedUrl);

    let content = alumniProfile ? alumniProfile[0] : {};
    setProffInfo({ ...content });
  }, []);
  console.log("mentors", alumniProfile, id, proffInfo);
  return (
    <div className=" form-div connect-page user-profile ">
      <div className="profile-page">
        <div className="bc">
          <div
            onClick={() =>
              alumniProfileType === "alumni"
                ? navigate("/application/alumni/connect")
                : navigate("/application/alumni/scholars")
            }
            className="left-btn upload-top-text"
          >
            <NavigateNextIcon fontSize="small" />
            Back to {alumniProfileType === "alumni"
              ? "Alumni"
              : "Scholars"}{" "}
          </div>
        </div>
        <div className="mentor-card">
          <div className="image">
            {/* <img src={avatar} alt="avatar" /> */}
            {proffInfo?.image && proffInfo?.imageExtension && (
              <img
                // className="image"
                src={
                  "data:image/" +
                  proffInfo?.imageExtension +
                  ";base64," +
                  proffInfo?.image
                }
                alt="Preview"
                // style={{ maxWidth: "100%", height: "100%" }}
              />
            )}
          </div>
          <div className="mentor-right">
            <div className="mentor-top">
              <div className="top-left left">
                <div className="md-title">
                  {proffInfo?.fullName || proffInfo?.name}
                </div>
                <div className="set-title">{proffInfo?.expertise}</div>
                {proffInfo?.experience && (
                  <div className="exp-line ">
                    <div className="left">
                      <img src={exp} alt="avatar" />
                      {proffInfo?.experience.includes("years")?proffInfo?.experience : `${proffInfo?.experience} years`} of experience
                    </div>
                  </div>
                )}
              </div>
              <div className="top-left right">
                <Button
                  onClickHandler={() =>
                    setModalData({ ...ModalData, show: true })
                  }
                  type={"contained"}
                  value={
                    // Link.split("/")[2] === "alumni" ?
                    "Connect"
                    // : "Request Mentorship"
                  }
                />
              </div>
            </div>
            {Link.split("/")[2] !== "alumni" && (
              <div className="options">
                <div className="option-top md-desc">I can help you with</div>
                <div className="skill-set">
                  {proffInfo?.provideHelp?.split(",")?.map((item, index) => {
                    return (
                      <div key={index} className="skill subTitle">
                        {item}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {Link.split("/")[2] !== "alumni" && (
              <div className="options">
                <div className="option-top upload-top-text">
                  Professional Skills
                </div>
                <div className="skill-set">
                  {proffInfo?.professionalSkills
                    ?.split(",")
                    ?.map((item, index) => {
                      return (
                        <div key={index} className="skill subTitle">
                          {item}
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="college-line">
          <div className="role-text">
            College
            <span>{proffInfo?.college}</span>
          </div>
          <div className="role-text">
            Batch
            <span>{proffInfo?.batch}</span>
          </div>
        </div>
        {Link.split("/")[2] !== "alumni" && (
          <div className="tab-view">
            <ItemTab
              onChange={(e) => setTab(e)}
              list={[
                "Personal Details",
                "Professional Details",
                "Education Details",
              ]}
            />
          </div>
        )}
      </div>
      {/* {tab === "Personal Details" ? (
        <PersonalProfile item={proffInfo} />
      ) : tab === "Professional Details" ? (
        <ProfessionalProfile item={proffInfo} />
      ) : (
        <EduProfile item={proffInfo} />
      )} */}

      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          content={ModalData.desc}
          className={"mentor"}
          noCross={
            (ModalData.type === "submit" || ModalData.type === "network") &&
            true
          }

          // countDown={ModalData.countDown}
        >
          {ModalData.type === "confirm" ? (
            mentorContent()
          ) : ModalData.type === "network" ? (
            scholarContent()
          ) : (
            <Button
              onClickHandler={() =>
                setModalData({
                  ...ModalData,
                  type: "network",
                  title: "",
                  desc: "",
                })
              }
              value={"Okay"}
              type={"contained"}
            />
          )}
        </ModalComponent>
      )}
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default UserProfile;
